export default __webpack_public_path__ + "static/media/home-web-agency-img-02.6add53e7.jpg";